<template>
  <div class="d-flex justify-center align-center" style="width: 100%">
    <v-btn
      :input-value="editStore.cropping"
      depressed
      rounded
      small
      @click="editStore.cropping ? (editStore.cropping = false) : editStore.runLayerCrop++"
      :disabled="
        !editStore.selectedLayer ||
        (editStore.selectedLayer && editStore.selectedLayer.metadata.id.startsWith('remote-layer-'))
      "
      class="mr-2"
    >
      <v-icon small>mdi-crop</v-icon>
    </v-btn>
    <!-- <v-btn
      depressed
      rounded
      small
      :disabled="!editStore.selectedLayer || (editStore.selectedLayer && editStore.selectedLayer.metadata.id.startsWith('remote-layer-'))"
      class="mr-2"
    >
      <v-icon small>mdi-content-cut</v-icon>
    </v-btn> -->
    <v-btn
      depressed
      rounded
      small
      @click="editStore.runRemoveLayer++"
      :disabled="!editStore.selectedLayer"
      class="mr-2"
    >
      <v-icon small>mdi-delete</v-icon>
    </v-btn>
    <v-menu offset-y transition="slide-y-reverse-transition" rounded="lg" top>
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          small
          depressed
          rounded
          v-bind="attrs"
          v-on="on"
          @click.once="
            !accountStore.isLoggedIn || editStore.brandAssetsMounted ? null : brandAssetStore.fetchBrandAssets()
          "
        >
          {{ $t("newLayer") }}
          <v-icon right>mdi-plus</v-icon>
        </v-btn>
      </template>
      <v-card>
        <v-list dense subheader>
          <v-subheader>{{ $t("actions") }}</v-subheader>

          <v-list-item @click="editStore.runAddLayer++">
            <v-list-item-icon>
              <v-icon>mdi-layers-plus</v-icon>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t("addNewLayer") }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <v-list-item
            @click="
              editStore.brandAssetsMounted = true;
              brandAssetStore.manageAssets = true;
            "
            :two-line="!accountStore.isLoggedIn"
            :disabled="!accountStore.isLoggedIn || brandAssetStore.syncing"
          >
            <v-list-item-icon>
              <v-icon v-if="!brandAssetStore.syncing" :disabled="!accountStore.isLoggedIn">mdi-folder-heart</v-icon>
              <v-progress-circular v-else indeterminate size="20" disabled></v-progress-circular>
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ $t("manageBrandAssets") }}</v-list-item-title>
              <v-list-item-subtitle v-if="!accountStore.isLoggedIn" class="caption">{{
                $t("accountRequired")
              }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <div v-if="brandAssetStore.brandAssets.length > 0">
          <v-divider inset></v-divider>

          <v-list dense subheader>
            <v-subheader>
              {{ $t("brandAssets") }}
            </v-subheader>

            <v-list-item-group v-model="editStore.brandAssetsUrls" multiple color="primary">
              <v-list-item
                v-for="item in brandAssetStore.brandAssets.map((e) => ({
                  value: e.file.url,
                  text: e.file.name,
                }))"
                :key="item.value"
                :value="item.value"
              >
                <template v-slot:default="{ active }">
                  <v-list-item-action>
                    <v-checkbox :input-value="active"></v-checkbox>
                  </v-list-item-action>

                  <v-list-item-content>
                    <v-list-item-title>{{ item.text }}</v-list-item-title>
                  </v-list-item-content>
                </template>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </div>
      </v-card>
    </v-menu>

    <v-spacer></v-spacer>

    <v-tooltip bottom :disabled="$vuetify.breakpoint.mobile">
      <template v-slot:activator="{ on, attrs }">
        <v-btn
          depressed
          rounded
          small
          :disabled="
            editStore.cropping || (editStore.faceDetecting && !editStore.abortControllerAutoCrop) || editStore.exporting
          "
          @click="
            editStore.faceDetecting && editStore.abortControllerAutoCrop
              ? editStore.abortControllerAutoCrop?.abort()
              : editStore.runAutoCrop++
          "
          v-bind="attrs"
          v-on="on"
        >
          {{ $t("autoCrop") }}
          <v-progress-circular
            v-if="editStore.faceDetecting"
            :indeterminate="editStore.progress <= 5"
            :value="editStore.progress"
            :rotate="editStore.progress <= 5 ? null : -90"
            size="16"
            class="ml-2"
          ></v-progress-circular>
          <v-icon v-else right>mdi-auto-fix</v-icon>
        </v-btn>
      </template>
      <div style="max-width: 500px">{{ $t("autoCropNote") }}</div>
    </v-tooltip>

    <v-menu bottom offset-y transition="slide-y-transition" rounded="lg">
      <template v-slot:activator="{ on, attrs }">
        <v-btn class="d-none" depressed rounded small icon v-bind="attrs" v-on="on">
          <v-icon>mdi-dots-vertical</v-icon>
        </v-btn>
      </template>
    </v-menu>
  </div>
</template>

<script>
import { useEditStore } from "@/stores/edit";
import { useAccountStore } from "@/stores/account";
import { useBrandAssetStore } from "@/stores/brand-asset";

export default {
  name: "EditorControls",
  setup() {
    const editStore = useEditStore();
    const accountStore = useAccountStore();
    const brandAssetStore = useBrandAssetStore();
    return { editStore, accountStore, brandAssetStore };
  },
  data() {
    return {};
  },
};
</script>

<style scoped>
.v-list-item__action {
  margin: 0;
}
</style>
